import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NexleaderCopyLinkComponent } from '../../copy-link/copy-link.component';

/**
 * mode selects which shareable view the link points at:
 *   'ipsat'     — 1.0 Identity Profile (#/s/<id>) — the default, opened from
 *                 the 1.0 result page.
 *   'archetype' — 2.0 Archetype Report (#/s/<id>/archetype) — opened from the
 *                 2.0 report page (Steve 2026-07-07).
 * `shareableID` is the SurveyResult _id in both cases.
 */
export type ShareableIpsatMode = 'ipsat' | 'archetype';

@Component({
  selector: 'app-nexleader-shareable-ipsat-modal',
  standalone: true,
  imports: [CommonModule, NexleaderCopyLinkComponent],
  templateUrl: './shareable-ipsat-modal.component.html',
})
export class NexleaderShareableIpsatModalComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Input() shareableID!: string;
  @Input() mode: ShareableIpsatMode = 'ipsat';

  url!: string;
  text!: string;
  combined!: string;
  relativeLink!: string;
  title!: string;

  constructor() { }

  ngOnInit() {
    if (!this.shareableID)
      console.warn('A shareable IPSAT ID is required to create the URL');

    const isArchetype = this.mode === 'archetype';
    this.relativeLink = isArchetype
      ? '#/s/' + this.shareableID + '/archetype'
      : '#/s/' + this.shareableID;
    this.title = isArchetype
      ? 'Share your IPSAT 2.0 Archetype Report'
      : 'Share your result';
    this.text = isArchetype
      ? 'Here is my IPSAT 2.0 Archetype Report from myIPSAT.com'
      : 'Here are the results of my unique Identity Profile from myIPSAT.com';

    this.url = encodeURIComponent(
      location.href.split('#')[0] + this.relativeLink
    );

    this.combined = this.text + ': ' + this.url;
  }
}
